import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Slide, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { TransitionProps } from '@mui/material/transitions';
import { FONT_ENUM } from '../../types/global/fonts.types';
import CloseIcon from '../../components/CustomSVGIcons/CloseIcon';
import { AccountSubscriptions } from './AccountSubscriptions';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export interface IAccountSubscriptionModal {
    open: boolean;
    onClose: VoidFunction;
}
const AccountSubscriptionModal: React.FC<IAccountSubscriptionModal> = ({ onClose, open }) => {
    const { themeStyle } = useThemeContext();
    const themeui = useTheme();
    const fullScreen = useMediaQuery(themeui.breakpoints.down('md'));

    const renderProjct = (
        <Dialog
            scroll="paper"
            open={open}
            onClose={onClose}
            TransitionComponent={Transition}
            fullWidth={true}
            fullScreen={fullScreen}
            maxWidth={'lg'}
            PaperProps={{
                style: {
                    backgroundColor: fullScreen
                        ? theme[themeStyle].background_gradient.mid
                        : theme[themeStyle].form_background, // make this a color variable
                    width: '100%',
                    borderRadius: 0,
                    border: `0.5px solid ${theme[themeStyle].darkGray60}`,
                    backdropFilter: 'blur(8px)',
                    margin: 0,
                    maxHeight: '100vh',
                },
            }}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                outline: 'none',
                backgroundColor: theme[themeStyle].modal_dark,
            }}>
            <DialogTitle>
                <Box
                    sx={{
                        width: '100%',
                        height: 'fit-content',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                    <Typography
                        style={{
                            textAlign: 'left',
                            fontSize: 12,
                            fontStyle: 'normal',
                            fontWeight: '600',
                            color: theme[themeStyle].primary_white,
                            fontFamily: FONT_ENUM.MAIN_BOLD,
                        }}>
                        It seems like you have maxed out your free benefits for the month. Please consider subscribing
                    </Typography>
                    <CloseIcon onClick={onClose} style={{ cursor: 'pointer' }} stroke={theme[themeStyle].tag_white} />
                </Box>
            </DialogTitle>
            <DialogContent>
                <AccountSubscriptions onDone={onClose} isPromptMode />
            </DialogContent>
        </Dialog>
    );

    return renderProjct;
};

export { AccountSubscriptionModal };
